/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";

function setupResizableColumns(resizeHandleParentElement, handleId, stateObservable) {
	let defaultMinSize = 400;
	let dragTarget;
	let sx;
	let totalFlexWidth, totalOffsetWidth, originalLeftOffsetWidth;
	let parent = resizeHandleParentElement;
	let leftColumn = parent.previousElementSibling;
	let rightColumn = parent.nextElementSibling;
	let minSizeLeft = +leftColumn.getAttribute("data-resize-min-px") || defaultMinSize;
	let minSizeRight = +rightColumn.getAttribute("data-resize-min-px") || defaultMinSize;

	let state;
	if(typeof stateObservable === "function") {
		state = stateObservable;
	} else {
		state = function(){};
	}

	restore();

	state('idle');

	resizeHandleParentElement.addEventListener('mousedown', onMouseDown);

	let resizeObserver;
	if(window.ResizeObserver) {
		let resizeTimer;
		resizeObserver = new ResizeObserver(function(entries) {
			if(dragTarget) {
				saveSize();
				return;
			}
			state('resizing');
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(() => state('idle'), 1000);

			enforceSizeConstraints();
			saveSize();
		});

		resizeObserver.observe(leftColumn);
		resizeObserver.observe(rightColumn);
	}

	function saveSize() {
		localStorage.setItem(handleId + ".left-flex", window.getComputedStyle(leftColumn)["flex-grow"]);
		localStorage.setItem(handleId + ".right-flex", window.getComputedStyle(rightColumn)["flex-grow"]);
	}

	function restore() {
		let leftFlexWidth = localStorage.getItem(handleId + ".left-flex");
		let rightFlexWidth = localStorage.getItem(handleId + ".right-flex");
		if(leftFlexWidth) {
			leftColumn.style.flexGrow = leftFlexWidth;
		}
		if(rightFlexWidth) {
			rightColumn.style.flexGrow = rightFlexWidth;
		}
	}

	function enforceSizeConstraints() {
		let totalFlexWidth = (+window.getComputedStyle(leftColumn)["flex-grow"]) + (+window.getComputedStyle(rightColumn)["flex-grow"]);
		let totalOffsetWidth = leftColumn.offsetWidth + rightColumn.offsetWidth;

		let newLeftOffsetWidth = Math.max(
			Math.min(totalOffsetWidth - minSizeRight, leftColumn.offsetWidth),
			minSizeLeft);

		let leftFlexWidth = totalFlexWidth * newLeftOffsetWidth / totalOffsetWidth;
		leftColumn.style.flexGrow = leftFlexWidth;
		rightColumn.style.flexGrow = totalFlexWidth - leftFlexWidth;
	}

	function onMouseDown(evt) {
		if(evt.button == 0 && evt.target.classList.contains("resize-handle")) {
			state('resizing');
			dragTarget = evt.target;
			dragTarget.classList.add('active');
			sx = evt.pageX;
			totalFlexWidth = (+window.getComputedStyle(leftColumn)["flex-grow"]) + (+window.getComputedStyle(rightColumn)["flex-grow"]);
		 	totalOffsetWidth = leftColumn.offsetWidth + rightColumn.offsetWidth;
			originalLeftOffsetWidth = leftColumn.offsetWidth;
			document.addEventListener('mousemove', onMouseMove);
			document.addEventListener('mouseup', onMouseUp);
			evt.preventDefault();
		}
	}

	function onMouseMove(evt) {
		let dx = evt.pageX - sx;

		let newLeftOffsetWidth = Math.max(
			Math.min(totalOffsetWidth - minSizeRight, originalLeftOffsetWidth + dx),
			minSizeLeft);

		let leftFlexWidth = totalFlexWidth * newLeftOffsetWidth / totalOffsetWidth;
		leftColumn.style.flexGrow = leftFlexWidth;
		rightColumn.style.flexGrow = totalFlexWidth - leftFlexWidth;

		evt.preventDefault();
	}

	function onMouseUp(evt) {
		document.removeEventListener('mousemove', onMouseMove);
		document.removeEventListener('mouseup', onMouseUp);
		dragTarget.classList.remove('active');
		state('idle');
		dragTarget = null;
	}

	function destroy() {
		resizeHandleParentElement.removeEventListener('mousedown', onMouseDown);
		if(resizeObserver) {
			resizeObserver.disconnect();
		}
	}

	return {
		destroy
	};
}

ko.bindingHandlers.resizeHandleId = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		let { destroy } = setupResizableColumns(element, ko.unwrap(valueAccessor()), allBindings.get('resizeState'));
		ko.utils.domNodeDisposal.addDisposeCallback(element, destroy);
	},
	update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
	}
};
